var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "actions-editor" }, [
    !_vm.localActions || _vm.localActions.length === 0
      ? _c(
          "div",
          { staticClass: "empty-actions" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("p", [_vm._v("Henüz aksiyon eklenmedi")]),
            _vm._v(" "),
            _c(
              "a-button",
              { attrs: { type: "primary" }, on: { click: _vm.addAction } },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                _vm._v("\n            İlk Aksiyonu Ekle\n        "),
              ]
            ),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "actions-body" },
          [
            _c(
              "draggable",
              {
                staticClass: "actions-list",
                attrs: { handle: ".drag-handle" },
                on: { end: _vm.emitChange },
                model: {
                  value: _vm.localActions,
                  callback: function ($$v) {
                    _vm.localActions = $$v
                  },
                  expression: "localActions",
                },
              },
              _vm._l(_vm.localActions, function (action, index) {
                return _c(
                  "div",
                  { key: "action-" + index, staticClass: "action-card" },
                  [
                    _c(
                      "div",
                      { staticClass: "action-header" },
                      [
                        _c("i", { staticClass: "material-icons drag-handle" }, [
                          _vm._v("drag_indicator"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-select",
                          {
                            staticClass: "action-type-select",
                            attrs: { placeholder: "Aksiyon seçin" },
                            on: {
                              change: function ($event) {
                                return _vm.onActionTypeChange(action)
                              },
                            },
                            model: {
                              value: action.type,
                              callback: function ($$v) {
                                _vm.$set(action, "type", $$v)
                              },
                              expression: "action.type",
                            },
                          },
                          _vm._l(_vm.actionTypeOptions, function (opt) {
                            return _c(
                              "a-select-option",
                              { key: opt.value, attrs: { value: opt.value } },
                              [
                                _c("span", { staticClass: "action-option" }, [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v(_vm._s(opt.icon)),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(opt.label))]),
                                ]),
                              ]
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            attrs: { type: "text", size: "small", danger: "" },
                            on: {
                              click: function ($event) {
                                return _vm.removeAction(index)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("delete"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    action.type && action.type !== "none"
                      ? _c(
                          "div",
                          { staticClass: "action-config" },
                          [
                            action.type === "add-assignee"
                              ? _c("AddAssigneeConfig", {
                                  on: { input: _vm.emitChange },
                                  model: {
                                    value: action.addAssignee,
                                    callback: function ($$v) {
                                      _vm.$set(action, "addAssignee", $$v)
                                    },
                                    expression: "action.addAssignee",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            action.type === "remove-assignee"
                              ? _c("RemoveAssigneeConfig", {
                                  on: { input: _vm.emitChange },
                                  model: {
                                    value: action.removeAssignee,
                                    callback: function ($$v) {
                                      _vm.$set(action, "removeAssignee", $$v)
                                    },
                                    expression: "action.removeAssignee",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            action.type === "change-owner"
                              ? _c("ChangeOwnerConfig", {
                                  on: { input: _vm.emitChange },
                                  model: {
                                    value: action.changeOwner,
                                    callback: function ($$v) {
                                      _vm.$set(action, "changeOwner", $$v)
                                    },
                                    expression: "action.changeOwner",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            action.type === "add-follower"
                              ? _c("AddFollowerConfig", {
                                  on: { input: _vm.emitChange },
                                  model: {
                                    value: action.addFollower,
                                    callback: function ($$v) {
                                      _vm.$set(action, "addFollower", $$v)
                                    },
                                    expression: "action.addFollower",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            action.type === "remove-follower"
                              ? _c("RemoveFollowerConfig", {
                                  on: { input: _vm.emitChange },
                                  model: {
                                    value: action.removeFollower,
                                    callback: function ($$v) {
                                      _vm.$set(action, "removeFollower", $$v)
                                    },
                                    expression: "action.removeFollower",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            action.type === "move-stage"
                              ? _c("MoveStageConfig", {
                                  attrs: { "workflow-id": _vm.workflowId },
                                  on: { input: _vm.emitChange },
                                  model: {
                                    value: action.moveStage,
                                    callback: function ($$v) {
                                      _vm.$set(action, "moveStage", $$v)
                                    },
                                    expression: "action.moveStage",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            action.type === "change-priority"
                              ? _c("ChangePriorityConfig", {
                                  on: { input: _vm.emitChange },
                                  model: {
                                    value: action.changePriority,
                                    callback: function ($$v) {
                                      _vm.$set(action, "changePriority", $$v)
                                    },
                                    expression: "action.changePriority",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            action.type === "add-collaborator"
                              ? _c("AddCollaboratorConfig", {
                                  on: { input: _vm.emitChange },
                                  model: {
                                    value: action.addCollaborator,
                                    callback: function ($$v) {
                                      _vm.$set(action, "addCollaborator", $$v)
                                    },
                                    expression: "action.addCollaborator",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            action.type === "add-tag"
                              ? _c("AddTagConfig", {
                                  on: { input: _vm.emitChange },
                                  model: {
                                    value: action.addTag,
                                    callback: function ($$v) {
                                      _vm.$set(action, "addTag", $$v)
                                    },
                                    expression: "action.addTag",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            action.type === "remove-tag"
                              ? _c("RemoveTagConfig", {
                                  on: { input: _vm.emitChange },
                                  model: {
                                    value: action.removeTag,
                                    callback: function ($$v) {
                                      _vm.$set(action, "removeTag", $$v)
                                    },
                                    expression: "action.removeTag",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            action.type === "set-start-date"
                              ? _c("SetDateConfig", {
                                  attrs: { label: "Başlangıç Tarihi" },
                                  on: { input: _vm.emitChange },
                                  model: {
                                    value: action.setStartDate,
                                    callback: function ($$v) {
                                      _vm.$set(action, "setStartDate", $$v)
                                    },
                                    expression: "action.setStartDate",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            action.type === "set-end-date"
                              ? _c("SetDateConfig", {
                                  attrs: { label: "Bitiş Tarihi" },
                                  on: { input: _vm.emitChange },
                                  model: {
                                    value: action.setEndDate,
                                    callback: function ($$v) {
                                      _vm.$set(action, "setEndDate", $$v)
                                    },
                                    expression: "action.setEndDate",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            action.type === "create-checklist"
                              ? _c("CreateChecklistConfig", {
                                  on: { input: _vm.emitChange },
                                  model: {
                                    value: action.createChecklist,
                                    callback: function ($$v) {
                                      _vm.$set(action, "createChecklist", $$v)
                                    },
                                    expression: "action.createChecklist",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            action.type === "create-comment"
                              ? _c("CreateCommentConfig", {
                                  on: { input: _vm.emitChange },
                                  model: {
                                    value: action.createComment,
                                    callback: function ($$v) {
                                      _vm.$set(action, "createComment", $$v)
                                    },
                                    expression: "action.createComment",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            action.type === "send-email"
                              ? _c("SendEmailConfig", {
                                  on: { input: _vm.emitChange },
                                  model: {
                                    value: action.sendEmail,
                                    callback: function ($$v) {
                                      _vm.$set(action, "sendEmail", $$v)
                                    },
                                    expression: "action.sendEmail",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            action.type === "send-web-notification"
                              ? _c("SendWebNotificationConfig", {
                                  on: { input: _vm.emitChange },
                                  model: {
                                    value: action.sendWebNotification,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        action,
                                        "sendWebNotification",
                                        $$v
                                      )
                                    },
                                    expression: "action.sendWebNotification",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            action.type === "webhook"
                              ? _c("WebhookConfig", {
                                  on: { input: _vm.emitChange },
                                  model: {
                                    value: action.webhook,
                                    callback: function ($$v) {
                                      _vm.$set(action, "webhook", $$v)
                                    },
                                    expression: "action.webhook",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "add-action-btn", on: { click: _vm.addAction } },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("add_circle"),
                ]),
                _vm._v(" "),
                _c("span", [_vm._v("Aksiyon Ekle")]),
              ]
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "empty-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("flash_off")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }